<template>
	<header class="header-main-top" :class="isOnboardingActive && 'zindex-0'">
		<div v-if="isLoading" class="w-100" style="position: fixed; z-index: 9999; display: flex; align-items: center; justify-content: center; backdrop-filter: blur(2px)">
			<Spinner id="nomargin" />
		</div>
		<div class="header-main d-flex justify-content-between align-items-center">
			<div class="d-flex align-items-center">
				<!-- <div @click="menuStatus ? closeSideBar() : expandSideBar()">
          <img src="../../assets/3dotsanddash.svg" alt="" />
        </div> -->
				<div
					class="cv-logo mr-2 ml-3 d-flex align-items-center"
					@click="isViewProfile ? '' : goToHome()"
				>
					<img
						src="https://cvstaticfiles.s3.ap-south-1.amazonaws.com/Hire3xAssests/Logo/SVG/Hire3xbeta_logo.svg"
						alt=""
					/>
				</div>
				<div
					style="width: auto"
					class="cv-bulders-path d-flex align-items-center ml-2"
					v-if="$route.name != 'PanelDetails'"
				>
					<!-- <router-link :to="{ name: 'Homepage' }" v-if="display"> -->
					<!-- <h6 class="m-0 hover-color">Candidate</h6> -->
					<h6
						class="m-0"
						:class="
							progressPrimary.progress >= 20 ||
							$route.name != 'CandidateDashboard'
								? 'pointer'
								: 'defaultCursor'
						"
						v-if="display"
						@click="goToHome()"
					>
						{{ rootLabel }}
					</h6>
					<!-- </router-link> -->
					<span class="d-flex align-items-center cand-breadcrumb" v-if="display"
						><img class="mr-1" src="../../assets/img/path-forward.svg" alt="" />
						<b-breadcrumb>
							<b-breadcrumb-item
								class="d-flex"
								v-for="(item, index) in levelList"
								:key="item.path"
								:active-class="item.meta.title"
								:active="item.active"
							>
								<div
									v-if="
										item.redirect === 'noRedirect' ||
										index == levelList.length - 1
									"
									:class="
										index > levelList.length - 1
											? ''
											: item.meta.title.length > 24
											? 'breadcrumb-ellipsis2'
											: item.meta.title.length > 24
											? 'breadcrumb-ellipsis'
											: ''
									"
									class="no-redirect"
								>
									{{ item.meta.title }}
								</div>
								<div
									class="breadcrumbs-active-class pointer"
									:class="
										index > levelList.length - 2
											? ''
											: item.meta.title.length > 24
											? 'breadcrumb-ellipsis2'
											: item.meta.title.length > 24
											? 'breadcrumb-ellipsis'
											: ''
									"
									v-else
									@click.prevent="handleLink(item)"
								>
									{{ item.meta.title }}
								</div>
							</b-breadcrumb-item>
						</b-breadcrumb>
					</span>
				</div>
			</div>

			<div class="d-flex align-items-center" v-if="getToken()">
				<div class="d-flex align-items-center gap-35 mr-4 position-relative">
					<div
						class="notificationdd position-relative"
						ref="notificationddset"
						v-if="!isViewProfile"
					>
						<div
							class="pointer d-flex flex-column justify-content-center align-items-center position-relative"
							@click="isnotiDropdownOpen = !isnotiDropdownOpen"
						>
							<div
								:style="{
									right:
										unreadCount < 10
											? '17px'
											: unreadCount >= 10 && unreadCount <= 99
											? '10px'
											: '4px',
								}"
								class="notification-count-tag fw-M fs-600 fs-10 text-white fam-mont"
							>
								{{ unreadCount > 99 ? "99+" : unreadCount }}
							</div>
							<div v-if="isnotiDropdownOpen" class="home-page-line"></div>

							<img
								src="../../assets/img/header/blueBell.svg"
								v-if="isnotiDropdownOpen"
								alt=""
							/>
							<img v-else src="../../assets/img/header/greybell.svg" alt="" />
							<div
								:class="isnotiDropdownOpen ? 'resume-txt' : 'not-sel-home'"
								class="mt-1"
							>
								Notifications
							</div>
						</div>

						<Notifications
							v-if="isnotiDropdownOpen"
							@closeNotificationDropdown="isnotiDropdownOpen = false"
							@changeCountvalue="changeReadUnreadcount"
							@allRead="fetchUnreadCount"
						/>
					</div>

					<div class="position-relative mt-1" v-if="searchPlaceholder">
						<img
							class="resumes-search-image-position"
							src="../../assets/headerSearch.svg"
							alt=""
						/>
						<b-form-input
							class="resumes-search-input"
							:placeholder="searchPlaceholder"
							v-model="searchQuery"
							debounce="500"
							@update="EventBus.$emit('search', $event)"
							type="search"
							clearable
							autocomplete="off"
						>
						</b-form-input>
					</div>
					<div
						class="pointer d-flex flex-column justify-content-center align-items-center"
						@click="routeToHome()"
					>
						<div v-if="$route.name == 'Homepage'" class="home-page-line"></div>
						<img
							v-if="$route.name == 'Homepage'"
							src="../../assets/img/header/header-sel-home.svg"
							alt=""
						/>
						<img
							v-else
							class=""
							src="../../assets/img/header/header-unsel-home.svg"
							alt=""
						/>
						<div
							:class="$route.name == 'Homepage' ? 'resume-txt' : 'not-sel-home'"
							class="mt-1"
						>
							Home
						</div>
					</div>
					<div
						class="position-relative mr-2"
						v-if="count > 1 && $route.name != 'ViewPublicProfile'"
					>
						<div
							class="sp-active-main-container pointer"
							@click="showswitch = !showswitch"
							ref="switch"
						>
							<!-- :style="
								showswitch
									? 'border-top-left-radius: 8px;border-top-right-radius: 8px;'
									: 'border-radius: 8px;'
							" -->
							<img src="@/assets/switchapps/grid.svg" alt="" />
							<img
								v-show="!showswitch"
								src="@/assets/switchapps/chevron-down.svg"
								class="ml-2"
								alt=""
							/>
							<img
								v-show="showswitch"
								src="@/assets/switchapps/chevron-up.svg"
								class="ml-2"
								alt=""
							/>
						</div>
						<div
							class="allproj-dropdown justify-content-center"
							v-if="showswitch"
							ref="switch-body"
							v-closable="{
								exclude: ['switch-body', 'switch'],
								handler: 'closeSwitch',
							}"
						>
							<div class="allproj-card allproj-card-selected">
								<img src="../../assets/All-projects-icons/cand.svg" alt="" />

								<div class="allproj-card-head">Candidates</div>

								<div class="allproj-card-subhead">
									Login to resume builder, much more
								</div>
							</div>

							<div
								class="allproj-card"
								v-if="accessAssessment"
								@click="goToProject('assessment')"
							>
								<img src="../../assets/All-projects-icons/assess.svg" alt="" />

								<div class="allproj-card-head">Assessment</div>

								<div class="allproj-card-subhead">
									Create, manage assessment progress
								</div>
							</div>
							<div
								class="allproj-card"
								v-if="accessRecruitment"
								@click="goToProject('recruitment')"
							>
								<img src="../../assets/All-projects-icons/rec.svg" alt="" />

								<div class="allproj-card-head">Recruitement</div>

								<div class="allproj-card-subhead">
									Build & hire from our network, AI features
								</div>
							</div>
							<div
								class="allproj-card"
								v-if="accessTraining"
								@click="goToProject('training')"
							>
								<img
									src="../../assets/All-projects-icons/training.svg"
									alt=""
								/>

								<div class="allproj-card-head">Training</div>

								<div class="allproj-card-subhead">
									Create, manage & edit course videos
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="login-details position-relative">
					<!-- WHEN USER UPLOADS PROFILE PIC -->
					<div class="d-flex" ref="profile-image">
						<div
							class="mr-4"
							:class="
								showdpcard ? 'profilepic-border-active' : 'profilepic-border'
							"
							:style="
							    candidateInfo &&
								candidateInfo.primaryProfile &&
								candidateInfo.primaryProfile.isPrimaryProfilePictureUploaded
									? 'border: 2.5px solid #20639b'
									: 'border: 2.5px solid #fff;'
							"
						>
							<img
								@click="((showdpcard = !showdpcard), closeOpenDownload())"
								class="br-50 h-100 w-100 pointer"
								:src="userInfo.image"
								alt=""
							/>
						</div>
					</div>

					<!-- <div> -->
					<div
						class="tnt-sortcard headercard p-2 mt-2"
						@click="closeDpcard"
						v-if="showdpcard"
						v-closable="{
							exclude: ['profile-image'],
							handler: 'closeDpcard',
						}"
					>
						<!-- new design starts from here -->
						<div class="d-flex align-items-center profile-container w-100">
							<div style="width: 14%">
								<div class="d-flex">
									<div
										class="profile-container-img"
										:style="
											candidateInfo.primaryProfile &&
											candidateInfo.primaryProfile
												.isPrimaryProfilePictureUploaded
												? 'border: 2.5px solid #20639b'
												: 'border: 2.5px solid #fff;'
										"
									>
										<img
											@click="(showdpcard = !showdpcard), closeOpenDownload()"
											class="br-50 h-100 w-100 pointer"
											:src="userInfo.image"
											alt=""
										/>
									</div>
								</div>
							</div>
							<div
								:class="userInfo.displayName.length > 20 ? 'text-truncate' : ''"
								style="width: 86%; word-break: break-all"
								class="profile-container-font ml-2"
								v-if="candidateInfo && candidateInfo.primaryProfile"
							>
								{{ userInfo.displayName }}
							</div>
						</div>

						<div
							class="d-flex align-items-center mt-2 p-1 pointer hoverclass"
							@click="
								$router.push({
									name: 'MainProfile',
								})
							"
						>
							<div class="mr-2">
								<img
									class="h-100 w-100"
									src="../../assets/New Profile/Settings.svg"
									alt=""
								/>
							</div>
							<div class="profile-container-subhead">Account Settings</div>
						</div>
						<div
							v-if="userInfo.isPanelistVerified"
							@click="goToPayment()"
							class="d-flex align-items-center mt-2 p-1 pointer hoverclass"
						>
							<div class="mr-2">
								<img
									class="h-100 w-100"
									src="../../assets/New Profile/bills.svg"
									alt=""
								/>
							</div>
							<div class="profile-container-subhead">Hire3x Wallet</div>
						</div>
						<div
							class="d-flex align-items-center mt-2 p-1 pointer hoverclass"
							@click="goToHelp()"
						>
							<div class="mr-2">
								<img
									class="h-100 w-100"
									src="../../assets/New Profile/Help.svg"
									alt=""
								/>
							</div>
							<div class="profile-container-subhead">Help</div>
						</div>

						<div class="new-profile-line mt-2"></div>

						<div
							class="d-flex align-items-center justify-content-center pointer p-1 hoverclass"
							@click="logout()"
						>
							<div class="mr-1">
								<img
									class="h-100 w-100"
									src="../../assets/New Profile/Logout.svg"
									alt=""
								/>
							</div>
							<div class="sign-out-font">Log Out</div>
						</div>
					</div>
					<!-- </div> -->
				</div>
			</div>
			<div v-else class="d-flex align-items-center">
				<b-button
					class="d-flex justify-content-end candash-cancelBtn mr-3 pointer"
					@click="openLoginModal()"
				>
					Login
				</b-button>
				<b-button
					@click="signup()"
					class="d-flex justify-content-end candash-addBtn mr-3 pointer"
				>
					Sign Up
				</b-button>
			</div>

			<b-modal id="saveresume" size="md" centered hide-footer hide-header>
				<div class="d-flex">
					<div class="w-100">
						<div class="candash-modal-body-3 p-3">
							<div class="d-flex align-items-start">
								<div>
									<img
										src="../../assets/newdesign/dashboard/creaNewPro.svg"
										alt=""
									/>
								</div>
								<div class="w95 pl-3">
									<div
										class="d-flex align-items-center justify-content-between"
									>
										<div class="candash-modal-head">Save Resume</div>
										<div class="pointer" @click="$bvModal.hide('saveresume')">
											<img
												class="rotate-on-hover"
												src="../../assets/newdesign/dashboard/blueCross.svg"
												alt=""
											/>
										</div>
									</div>
									<div class="candash-blackTxt mt-2">Profile Name</div>
									<div class="w95 mt-2">
										<b-form-input
											placeholder="Enter name of the resume"
											type="text"
											class="laptopinput"
										>
										</b-form-input>
									</div>
								</div>
							</div>
						</div>
						<div class="p-3 d-flex align-items-center justify-content-end mt-3">
							<b-button class="candash-cancelBtn mr-4 pointer">Save</b-button>
							<b-button class="candash-addBtn pointer"
								>Save & Download</b-button
							>
						</div>
					</div>
				</div>
			</b-modal>
			<LogoutConfirmModal
				:visible="showLogoutModal"
				@confirm="confirmLogout"
				@cancel="cancelLogout"
			/>
		</div>
		<b-modal
			id="preferencemodal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
		>
			<div class="prefmodalheading d-flex align-items-center">
				Preference settings
			</div>
			<div class="mt-1 prefmodal-subhead">
				Let us know where we need to direct you once you login.You can later
				change this preference in settings.
			</div>
			<div class="prefmodal-radios mt-3">
				<b-form-radio
					v-if="accessRecruitment"
					v-model="selected"
					value="recruitment"
					>Recruitment</b-form-radio
				>
				<b-form-radio
					v-if="accessAssessment"
					v-model="selected"
					value="assessment"
					>Assessment</b-form-radio
				>
				<b-form-radio v-if="accessTraining" v-model="selected" value="training"
					>Training</b-form-radio
				>
				<b-form-radio
					v-if="accessCandidate"
					v-model="selected"
					value="candidate"
					>Candidate</b-form-radio
				>
			</div>
			<hr
				style="
					border-bottom: 1px solid rgba(128, 128, 128, 0.2);
					margin-top: 10px;
				"
			/>
			<div class="prefmodal-checkbox">
				<b-form-checkbox id="checkbox-1" v-model="status">
					Don’t show me this message again.
				</b-form-checkbox>
			</div>
			<div
				class="mt-4 d-flex align-items-center justify-content-end prefmodal-btns"
			>
				<b-button class="candash-cancelbtn" @click="closeval()"
					>Cancel</b-button
				>
				<b-button class="candash-addbtn ml-3" @click="setPref()"
					>Apply</b-button
				>
			</div>
		</b-modal>
	</header>
</template>

<script>
import LogoutConfirmModal from "../../components/BuilderPage/Cards/LogoutConfirmModal.vue";
import { mapGetters, mapMutations } from "vuex";
import EventBus from "../../utils/EventBus";
import {
	getAllProfiles,
	signOutDevices,
	userInfo,
	getNotificationData,
	postInstructorInformation,
	userAccess,
	getCandidatePrimaryProfile,
	getCandInfo,
	getProfileCompletion,
} from "../../utils/apiFunctions.js";
const { compile } = require("path-to-regexp");
import { getToken, getLoginType } from "../../utils/tokenCheck";
import { resumeValidations } from "../../controllers/dashboard/validations";
import errorModal from "../../components/mixin/toast";
import Loader from "../../components/fixedcomponents/Loader.vue";
import Notifications from "../../components/Notifications.vue";
import { Capacitor } from "@capacitor/core";
import { goToLogin } from "@/router";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import { config } from "@/config";
export default {
	name: "Header",
	mixins: [errorModal],
	data() {
		return {
			showLogoutModal: false,
			loopvar: 4,
			allMandatoryFilled: false,
			showCompletion: false,
			showOptions: false,
			resumeLoop: 20,
			value: null,
			max: 100,
			themeChange: false,
			levelList: null,
			selected: null,
			showswitch: false,
			display: true,
			showdpcard: false,
			status: false,
			count: 1,
			preferences: {},
			accessRecruitment: false,
			accessTraining: false,
			accessCandidate: true,
			accessAssessment: false,
			dontAskMeAgain: false,
			isDeletingResume: false,
			showTooltip: false,
			loggedin: null,
			selectedTheme: "",
			originalTheme: "",
			candidateEmail: "",
			primaryProfileDelete: "",
			profileName: "",
			display: "",
			profileId: null,
			recivedId: null,
			deleteOne: false,
			localCandidateInfo: Object,
			openDownload: false,
			viewAllResume: false,
			tabs: [
				"Personal Details",
				"Demographic",
				"Education",
				"Experience",
				"Skills",
				"Project",
				"Achievement",
				"Portfolio",
			],

			//For all profiles
			allProfileList: [],
			searchQuery: "",
			resumeName: null,
			isPrimary: [
				{ text: "Yes", value: true },
				{ text: "No", value: false },
			],
			selectedPrimaryOption: null,
			tabOption: [],
			tabNameList: [],
			delCheck: true,
			allProfileListNum: null,
			newProfileCreated: false,
			notificationsData: [],
			mandetoryItems: [],
			searchPlaceholder: "",
			showProfileListLoader: true,
			candDetails: {},
			isnotiDropdownOpen: false,
			isLoading: false,
			config,
		};
	},
	components: {
		Loader,
		Notifications,
		Spinner,
		LogoutConfirmModal,
	},

	mounted() {
		document.addEventListener("click", this.handleClickOutside);
	},

	beforeDestroy() {
		document.removeEventListener("click", this.handleClickOutside);
		EventBus.$off("get-information", this.getInformation);
		EventBus.$off("passFilledInfo", this.checkFilledInfoMandetory);
		EventBus.$off("updateSearchQuery");
		EventBus.$off("login-success", this.onLoginSuccess);
		EventBus.$off("onboarding-fetch-post-login", this.fetchUnreadCount);
		EventBus.$off("profileModalNew", this.openProfileModal);
		EventBus.$off("open-resume-clinic");
	},
	created() {
		this.fetchUnreadCount();
		this.setPlaceholder();
		if (this.userInfo?.offers?.instrcutor_application) {
			this.instructorStatus();
		} else this.getCookieData();
		EventBus.$on("get-information", this.getInformation);
		EventBus.$on("passFilledInfo", this.checkFilledInfoMandetory);
		EventBus.$on("updateSearchQuery", (query) => {
			this.searchQuery = query;
		});
		EventBus.$on("login-success", this.onLoginSuccess);
		EventBus.$on("onboarding-fetch-post-login", this.fetchUnreadCount);
		EventBus.$on("spinner-start", this.onLoginSuccess);
		EventBus.$on("open-resume-clinic", () => {
            this.isLoading = false;
        });
		this.getBreadcrumb();

		this.candDetails = this.candidateInfo;
		EventBus.$on("profileModalNew", this.openProfileModal);
	},
	validations() {
		return {
			...resumeValidations(this),
		};
	},
	watch: {
		$route(route) {
			// if you go to the redirect page, do not update the breadcrumbs
			if (route.path.startsWith("/redirect/")) {
				return;
			}
			this.getBreadcrumb();
			this.getTitleName(route);
			this.setPlaceholder();
		},
		candidateInfo: function (newCandidateInfo, oldCandidateInfo) {
			this.candDetails = newCandidateInfo;
			this.checkGraphicalResumeProperty();
			if (Object.keys(this.candidateInfo).length != 0) {
				this.candDetails = newCandidateInfo;
			}
		},
		userInfo(newVal) {
			if (newVal) {
				console.log('userInfochnaged', newVal)
				// this.userInfo = newVal;
			}
		},
	},
	computed: {
		unreadCount(){
			if(this.showUnreadCount) return this.showUnreadCount;
			else return 0;
		},
		EventBus() {
			return EventBus;
		},
		...mapGetters("userVUEX", {
			vuexToken: "getToken",
			// getShowPref: "getShowPref",
			username: "getUserName",
			menuStatus: "getMenuStatus",
			pageTitle: "getPageTitle",
			// token: "getToken",
			userEmail: "getUserEmail",
			userInfo: "getUserInfo",
			showUnreadCount: "getUnreadCount",
		}),

		...mapGetters("candidateVUEX", {
			progress: "getCandProgressResp",
			progressPrimary: "getCandProgressRespPrimary",
			candidateInfo: "getcandidateInfo",
			toggleNotification: "getToggleNotification",
			primaryCandidateInfo: "getPrimaryCandidateInfo",
			isOnboardingActive: "getIsOnboardingActive",
		}),

		isViewProfile() {
			return this.$route.name === "InterviewOngoing";
		},
		
		token() {
			return this.vuexToken || getToken();
		},

		rootLabel() {
			return "Candidate";
		},
		switchBreadcrumbs() {
			let matched = this.$route.matched.filter(
				(item) => item.meta && item.meta.title
			);

			switch (this.$route.name) {
				default:
					this.display = false;
					return null;
				case "Games":
					this.display = true;
					matched.splice(0, 1, {
						redirect: "noRedirect",
						meta: {
							title: "Games",
						},
					});
					return matched;
				case "SingleGame":
					this.display = true;
					matched.splice(
						0,
						1,
						{
							name: "Games",
							meta: {
								title: "Games",
							},
						},
						{
							redirect: "noRedirect",
							meta: {
								title: this.capitalizeFirstLetter(this.$route.query.gameType),
							},
						}
					);
					return matched;
				case "AssessmentMarketplace":
					this.display = true;

					matched.splice(0, 1, {
						redirect: "noRedirect",
						meta: {
							title: "Categories",
						},
					});

					if (this.$route.query.category != null) {
						matched.splice(
							0,
							1,
							{
								// name: "AssessmentCategory",
								// redirect: "noRedirect",
								goBack: "category",
								meta: {
									title: "Categories",
								},
								// query: {
								// 	category: "",
								// 	categoryTitle: "",
								// },
							},
							{
								redirect: "noRedirect",
								meta: {
									title: this.$route.query.categoryTitle,
								},
							}
						);
					}
					return matched;

				case "MainProfile":
					this.display = true;
					matched.splice(0, 1, {
						redirect: "noRedirect",
						meta: {
							title: "Account Settings",
						},
					});
					return matched;
				case "CandidateDashboard":
					this.display = true;
					matched.splice(0, 1, {
						redirect: "noRedirect",
						meta: {
							title: "Resume Builder",
						},
					});
					return matched;
				case "Homepage":
					this.display = true;
					matched.splice(0, 1, {
						redirect: "noRedirect",
						meta: {
							title: "Home",
						},
					});
					return matched;
				case "streaks":
				case "mobstreaks":
					this.display = true;
					matched.splice(0, 1, {
						redirect: "noRedirect",
						meta: {
							title: "Streaks",
						},
					});
					return matched;
				case "InterviewKickstart":
					this.display = true;
					matched.splice(
						0,
						1,
						{
							name: this.$route.query.from === "home" ? "Homepage" : "CandidateDashboard",
							query: this.$route.query,
							meta: {
								title: this.$route.query.from === "home" ? "Home" : "Resume Builder",
							},
						},
						{
							redirect: "noRedirect",
							meta: {
								title: "Prepare for an interview",
							},
						}
					);
					return matched;
				case "InterviewSkills":
					this.display = true;
					matched.splice(
						0,
						1,
						{
							name: this.$route.query.from === "home" ? "Homepage" : "CandidateDashboard",
							query: this.$route.query,
							meta: {
								title: this.$route.query.from === "home" ? "Home" : "Resume Builder",
							},
						},
						{
							name: "InterviewKickstart",
							query: this.$route.query,
							meta: {
								title: "Prepare for an interview",
							},
						},
						{
							redirect: "noRedirect",
							meta: {
								title: this.$route.query.byskill
									? "Prepare By Skill"
									: "Prepare By Company/Role",
							},
						}
					);
					return matched;
				case "PrepareInterview":
					this.display = true;
					matched.splice(
						0,
						1,
						{
							name: this.$route.query.from === "home" ? "Homepage" : "CandidateDashboard",
							query: this.$route.query,
							meta: {
								title: this.$route.query.from === "home" ? "Home" : "Resume Builder",
							},
						},
						{
							name: "InterviewKickstart",
							query: this.$route.query,
							meta: {
								title: "Prepare for an interview",
							},
						},
						{
							redirect: "noRedirect",
							meta: {
								title: this.$route.query.skill || "Prepare",
							},
						}
					);
					return matched;
				case "CandidateDocsList":
					this.display = true;
					matched.splice(0, 1, {
						redirect: "noRedirect",
						meta: {
							title: "Upload Documents",
						},
					});
					return matched;
				case "Leaderboard":
					this.display = true;
					matched.splice(
						0,
						1,
						{
							name: "Games",
							meta: {
								title: "Games",
							},
						},
						{
							redirect: "noRedirect",
							meta: {
								title: "Leaderboard",
							},
						}
					);
					return matched;
				case "CandidateAssessmentProgress":
					this.display = true;
					matched.splice(
						0,
						1,
						{
							name: "AssessmentCategory",
							meta: {
								title: "Categories",
							},
						},
						{
							name: "AssessmentCategory",
							meta: {
								title: this.$route.query.categoryTitle,
							},
							query: {
								category: this.$route.query.category,
								categoryTitle: this.$route.query.categoryTitle,
							},
						},
						{
							redirect: "noRedirect",
							meta: {
								title: this.$route.query.subCategoryTitle,
							},
						},
						{
							redirect: "noRedirect",
							meta: {
								title: "Assessment Progress",
							},
						}
					);
					return matched;
				case "JobSearch":
					this.display = true;
					matched.splice(0, 1, {
						redirect: "noRedirect",
						meta: {
							title: "Jobs",
						},
					});
					if (this.$route.query.bookmarked) {
						matched.splice(1, 0, {
							redirect: "noRedirect",
							meta: {
								title: "Saved Job",
							},
						});
					} else {
						matched.splice(1, 0, {
							redirect: "noRedirect",
							meta: {
								title: "Job Search",
							},
						});
					}
					return matched;
				case "GuestJobDetails":
					this.display = true;
					matched.splice(0, 1, {
						redirect: "noRedirect",
						meta: {
							title: "Job Info",
						},
					});
					return matched;
				case "JobProgress":
					this.display = true;
					matched.splice(
						0,
						1,
						{
							redirect: "noRedirect",
							meta: {
								title: "Jobs",
							},
						},
						{
							redirect: "noRedirect",
							meta: {
								title: "Applied Jobs",
							},
						}
					);
					return matched;
				case "UploadCandidateDocs":
				case "uploadDocuments":
				case "particularjobdetails":
				case "systempermission":
					this.display = true;
					return matched;
				case "addsnapshots":
					this.display = true;
					matched.splice(0, 0, {
						name: "systempermission",
						meta: {
							title: "System Permission",
						},
					});
					return matched;
				case "createresumevideo":
					this.display = true;
					matched.splice(
						0,
						0,
						{
							name: "systempermission",
							meta: {
								title: "System Permission",
							},
						},
						{
							name: "addsnapshots",
							meta: {
								title: "...",
								breadcrumbTitle: "Add Snapshots",
							},
						}
					);
					return matched;
				case "CandJdProgress":
					if (this.$route.query.redirect != undefined) {
						this.display = true;
						matched.splice(0, 0, {
							name: this.$route.query.redirect,
							meta: {
								title: "My Jobs",
							},
						});
						return matched;
					} else {
						this.display = false;
						return null;
					}

				case "GuestTestDetails":
					this.display = true;
					matched.splice(0, 1, {
						redirect: "noRedirect",
						meta: {
							title: "Test Details",
						},
					});
					return matched;

				case "AssessmentCategory":
					this.display = true;
					matched.splice(0, 1, {
						redirect: "noRedirect",
						meta: {
							title: "Assessment Progress",
						},
					});
					return matched;
				case "ViewPublicProfile":
					this.display = true;
					matched.splice(0, 1, {
						redirect: "noRedirect",
						meta: {
							title: "Profile",
						},
					});
					return matched;
			}
		},
		showheaderComponents() {
			if (this.$route?.query?.uuid) {
				return (
					this.progressPrimary.progress >= 20 &&
					this.primaryCandidateInfo.database_demographics &&
					this.candidateInfo.profileName !== null
				);
			}
			return (
				this.progressPrimary.progress >= 20 &&
				this.primaryCandidateInfo.database_demographics
			);
		},
	},
	methods: {
		closeSwitch() {
			this.showswitch = false;
		},
		async instructorStatus() {
			try {
				let payload = {
					email: this.userEmail,
				};
				const response = await postInstructorInformation(payload);
				if (response.status === 200) {
					if (response.data.data.data[0].instructorInfo.status === 1) {
						const res = await userAccess();
						let trainingAccess = res.data.details.filter(
							(obj) => obj.project == "training"
						)[0];
						if (
							trainingAccess &&
							trainingAccess.userPermissions &&
							trainingAccess.userPermissions.isActive
						) {
							document.cookie = `training=${JSON.stringify(
								trainingAccess
							)};expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
						}
					}
				}
			} catch (error) {
				console.error("API error:", error);
			}
			this.getCookieData();
		},
		goToProject(type) {
			let redirecturl;
			if (type === "recruitment")
				redirecturl = "https://recruitment.hire3x.com";
			else if (type === "assessment")
				redirecturl = "https://judge.hire3x.com";
			else if (type === "training")
				redirecturl =
					"https://trainingadmin.hire3x.com/?from=candidate";
			window.open(redirecturl);
			this.showswitch = false;
		},
		confirmLogout() {
			this.$store.commit("candidateVUEX/setResclinicRename", false);
			localStorage.clear();
			this.$store.dispatch("userVUEX/LogOut");
			this.allProfileList = [];
		},
		cancelLogout() {
			this.showLogoutModal = false;
		},
		async onLoginSuccess() {
			this.isLoading = true;
			if (this.userInfo?.offers?.instrcutor_application) {
				this.instructorStatus();
			} else this.getCookieData();
			setTimeout(() => {
				this.isLoading = false;
			}, 3000);
			this.$forceUpdate();
		},

		openLoginModal() {
			EventBus.$emit("open-login-modal");
		},
		getToken() {
			return getToken();
		},
		changeReadUnreadcount(change) {
			this.unreadCount += change;
		},
		handleClickOutside(event) {
			const notificationEl = this.$refs.notificationddset;

			if (notificationEl && !notificationEl.contains(event.target)) {
				this.closeNotificationcard();
			}
		},
		async fetchUnreadCount() {
			this.$store.dispatch("userVUEX/fetchUnreadCount");
		},
		goToPayment() {
			if (Capacitor.isNativePlatform())
				window.location.replace("https://utility.hire3x.com/wallet");
			else window.open("https://utility.hire3x.com/wallet");
		},
		openProfileModal() {
			this.toggleMyProfile();
			this.$bvModal.show("Profilesmodal");
		},
		routeToHome() {
			this.$router.push({ path: "/homepage" });
			this.closeDpcard();
		},
		setPlaceholder() {
			switch (this.$route.name) {
				default:
					this.searchPlaceholder = "";
					break;
			}
		},

		capitalizeFirstLetter(string) {
			if (!string) return "";
			return string.charAt(0).toUpperCase() + string.slice(1);
		},

		async getInformation() {
			const res = await userInfo();
			if (res.status == 200) {
				this.candidateInfo.primaryProfile.primaryImage = res.data.data.image;
			}
		},

		async toggleMyProfile() {
			this.allProfileListNum = null;
			this.searchQuery = "";
			await this.getAllProfiles();
			this.openDownload = !this.openDownload;
			this.viewAllResume = false;
			this.closeDpcard();
		},

		myProfile() {
			this.$router.push({
				name: "CandidateDashboard",
			});
		},
		signup() {
			goToLogin((callback) => {
				callback({ name: "Login" });
			});
		},

		login() {
			if (this.$route.name == "ViewPublicProfile") {
				location.replace(
					`${this.config.websiteBase}login?redirect=${this.$route.fullPath}`
				);
			} else {
				location.replace(`${this.config.websiteBase}login`);
			}
		},
		goToHome() {
			if (this.progressPrimary.progress >= 20) {
				this.$router.push({
					name: "Homepage",
				});
			} else {
				this.$router.push({
					name: "CandidateDashboard",
				});
			}
		},

		goToMyProfile() {
			this.$router.push({
				name: "MyProfile",
			});
			this.closeDpcard();
		},
		goToHelp() {
			window.open(`${this.config.websiteBase}contactus`);
		},

		listOfIndustryResp() {
			this.getTabOptions(this.candidateInfo.industry);
		},
		handleRadioChange() {
			if (!this.selectedPrimaryOption) {
				this.tabNameList = [];
			} else {
				this.tabNameList.push("personalDetails", "demographics");
			}
		},
		checkGraphicalResumeDownload() {
			this.$bvModal.hide("Profilesmodal");
			EventBus.$emit("downloadGraphicalResume");
		},
		checkGraphicalResumeProperty() {
			// return Object.keys(this.candidateInfo.graphicalResume).length != 0;
			return this.progress.createNewProfile;
		},
		handleHover() {
			this.showdpcard = !this.showdpcard;
		},
		closeOpenDownload() {
			this.openDownload = false;
			this.viewAllResume = false;
		},
		closeDpcard() {
			this.showdpcard = false;
		},
		closeNotificationcard() {
			this.isnotiDropdownOpen = false;
		},
		addTabName(formIds) {
			if (this.tabNameList.includes(formIds)) {
				const index = this.tabNameList.indexOf(formIds);
				if (index > -1) {
					this.tabNameList.splice(index, 1);
				}
			} else {
				this.tabNameList.push(formIds);
				this.invalidSelection = false;
			}
			// this.$forceUpdate();
		},

		closeModal() {
			this.resumeName = null;
			this.selectedPrimaryOption = null;
			this.tabNameList = [];
			this.$nextTick(() => {
				this.$v.$reset();
			});
			this.$bvModal.hide("saveAs");
			this.invalidSelection = false;
			this.closeOpenDownload();
			this.closeDpcard();
		},

		// namevalidation(e) {
		//   if (!e.key.match(/^[a-zA-Z\s\b]*$/)) {
		//     e.preventDefault();
		//   }
		// },

		...mapMutations({
			setTheme: "userVUEX/setSelectedTheme",
		}),
		handleLink(item) {
			const { redirect, path, name, query, goBack } = item;
			if (redirect) {
				this.$router.push(redirect);
				return;
			}
			if (name) {
				this.$router.push({
					name: name,
					params: item.params,
					query: query,
				});
				return;
			}
			if (query) {
				this.$router.push({
					path: path,
					query: query,
				});
				return;
			}
			if (goBack === "category") {
				const message = "goback";
				EventBus.$emit("message-sent", message);
				return;
			}

			// Handle regular navigation
			this.$router.push(this.pathCompile(path));
		},

		pathCompile(path) {
			const { params } = this.$route;
			var toPath = compile(path);
			return toPath(params);
		},

		async getAllProfiles() {
			this.showProfileListLoader = true;
			try {
				const res = await getAllProfiles(this.searchQuery);
				if (res.status == 200) {
					this.allProfileList = res.data.data.map((obj) => ({
						profileName: obj.profileName,
						_id: obj._id,
						draft: obj.draft,
						primary: obj.primary,
					}));

					if (!this.allProfileListNum) {
						this.allProfileListNum = this.allProfileList.length;
					}
					this.$forceUpdate();
				} else {
					console.log("Api error");
				}
			} catch (error) {
				console.log(error);
			}
			this.showProfileListLoader = false;
		},
		getBreadcrumb() {
			if (this.switchBreadcrumbs) {
				this.levelList = this.switchBreadcrumbs.filter(
					(item) =>
						item.meta && item.meta.title && item.meta.breadcrumb !== false
				);
				this.levelList[this.levelList.length - 1].active = true;
			}
		},

		// MAKE THE SIDE BAR WIDTH FIXED
		expandSideBar() {
			this.$store.commit("userVUEX/setMenuStatus", true);
		},
		// CLOSE THE FIXED SIDEBAR
		closeSideBar() {
			this.$store.commit("userVUEX/setMenuStatus", false);
		},
		async confirmLogout() {
			this.showDeviceActivityShimmer = true;
			this.$store.commit("candidateVUEX/setResclinicRename", false);
			try {
				if (!getLoginType().logged_in || getLoginType().logged_in != "google") {
					let payload = {
						id: localStorage.getItem("currentLogin"),
					};
					await signOutDevices(payload); // Call the API to sign out of the specific device
					this.$socket.emit("signOut", {
						email: localStorage.getItem("currentEmail"),
						userid: payload,
					});
				}
				// this.$store.commit("candidateVUEX/setCandidateInfo", {});
				localStorage.clear();
				this.$store.dispatch("userVUEX/LogOut");
				this.allProfileList = [];
			} catch (error) {
				this.errorModal("Error", "An error occurred"); // Show error toast
				this.cancelLogout();
				console.error("Error:", error); // Log the error to the console
			}
		},
		logout() {
			this.showLogoutModal = true;
		},
		selectTheme(theme) {
			// Update the selected theme in the component state
			this.selectedTheme = theme;
		},

		cancelTheme() {
			// Reset the selected theme to the original theme
			this.selectedTheme = this.originalTheme;
			this.themeChange = false;
		},
		getCookieData() {
			let data = document.cookie.split(";");
			for (let i in data) {
				let token = data[i].split("=")[0];
				if (token.trim() === "assessment") {
					this.accessAssessment = data[i].split("=")[1] !== "no-access";
					this.accessAssessment ? this.count++ : "";
				}
				if (token.trim() === "training") {
					this.accessTraining = data[i].split("=")[1] !== "no-access";
					this.accessTraining ? this.count++ : "";
				}
				if (token.trim() === "recruitment") {
					this.accessRecruitment = data[i].split("=")[1] !== "no-access";
					this.accessRecruitment ? this.count++ : "";
				}
			}
		},
		async getPref() {
			try {
				const res = await getPreference();
				if (res.status == 200) {
					this.preferences = res.data.data;
					this.selected = this.preferences.defaultModule;
					this.status = this.preferences.dontAskMeAgain;

					if (!this.status && getShowPreference().showPreference) {
						this.checkpref();
					}
				}
			} catch (error) {
				console.log(error);
			}
		},
		async setPref() {
			// this.$store.commit("userVUEX/setShowPref", true);
			try {
				let payload = {
					defaultModule: this.selected,
					dontAskMeAgain: this.status,
				};
				const res = await postPreference(payload);
				if (res.status == 200) {
					this.$bvModal.hide("preferencemodal");
					setShowPreference(getShowPreference());
					// this.successModal("Preference updated successfully");
					this.getPref();
				}
			} catch (error) {
				console.log(error);
			}
		},
		checkpref() {
			console.log(this.count);
			if (this.count > 1) {
				this.$nextTick(() => {
					this.$bvModal.show("preferencemodal");
				});
			}
		},
		closeval() {
			// this.$store.commit("userVUEX/setShowPref", true);
			setShowPreference(getShowPreference());
			this.$bvModal.hide("preferencemodal");
			this.getPref();
		},
		getSvgPath() {
			return svgPath50(this);
		},

		getSvgPath2() {
			return svgPath85(this);
		},

		gotoLogin() {
			clearCookies();
			// window.location.replace("http://localhost:8080/login/")
			window.location.replace(`${this.config.websiteBase}login`);
		},
		getTitleName(value) {
			if (value.name == "CandJdProgress" && !this.$route.query.redirect) {
				this.title = { titleName: "JD Progress", path: "/jobdetails" };
			} else if (value.name == "CandidateAssessmentProgress") {
				this.title = { titleName: "Assessment", path: "/assessments" };
			} else if (
				value.name == "CandidateDocsList" ||
				value.name == "documentsUpload"
			) {
				this.title = { titleName: "Documents", path: "/documents" };
			} else if (
				value.name == "jobsearch" ||
				value.name == "particularjobdetails" ||
				this.$route.query.redirect == "particularjobdetails"
			) {
				this.title = { titleName: "Job Search", path: "/jobsearch" };
			} else if (this.checkVideoResume) {
				this.title = { titleName: "Video Resume", path: "/videoresume" };
			} else if (this.checkdocsDashboard) {
				this.title = { titleName: "Dashboard", path: "/dashboard" };
			} else if (value.name == "Profile") {
				this.title = { titleName: "Profile", path: "/profile" };
			}
		},

		checkFilledInfoMandetory(allMand) {
			if (!this.candidateInfo.database_demographics || allMand.length < 1) {
				this.allMandatoryFilled = true;
			} else {
				this.mandetoryItems = allMand;
				this.mandetoryItems = this.mandetoryItems.filter(
					(obj) => obj.isMandetory === true
				);
				this.allMandatoryFilled = this.mandetoryItems.every(
					(item) => item.filled === true
				);
			}
			// else{
			//   this.allMandatoryFilled = true;
			// }
		},
	},
};
</script>
<style>
.prefmodal-btns .btn-light {
	border-radius: 4px;
	border: 1px solid var(--gray-300, #d0d5dd);
	color: var(--gray-900, #101828);
	font-family: "Inter", sans-serif;
	font-size: 14px;
	font-weight: 500;
}
.prefmodal-btns .btn-primary {
	border-radius: 4px;
	background: #4c78ce;
	color: #fff;
	font-family: "Inter", sans-serif;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
}
.prefmodal-checkbox .custom-control-label {
	position: relative;
	margin-bottom: 0;
	vertical-align: top;
	color: var(--gray-700, #344054);
	font-family: "Inter", sans-serif;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
}
.prefmodal-checkbox .custom-control-label::before {
	border-radius: 2px;
	border: 1px solid var(--gray-300, #d0d5dd);
	background: var(--White, #fff);
}

.prefmodal-checkbox
	.custom-control-input:checked
	~ .custom-control-label::before {
	color: #fff;
	border-color: var(--bg-dynaminChange);
	background-color: var(--bg-dynaminChange);
}

.prefmodal-radios .custom-control {
	margin-top: 10px;
}
.prefmodal-radios .custom-control-label::before {
	border-radius: 10px;
	border: 1px solid var(--gray-300, #d0d5dd);
	background: var(--White, #fff);
}
.prefmodal-radios .custom-control-label::after {
	top: 4px;
}
.prefmodal-radios .custom-control-label {
	position: relative;
	margin-bottom: 0;
	vertical-align: top;
	color: var(--gray-700, #344054);
	font-family: "Inter", sans-serif;
	font-size: 14px;
	font-weight: 500;
}

.prefmodal-radios
	.custom-control-input:checked
	~ .custom-control-label::before {
	color: #fff;
	border-color: var(--bg-dynaminChange);
	background-color: var(--bg-dynaminChange);
}
.prefmodalheading {
	color: var(--gray-900, #101828);
	font-family: "Inter", sans-serif;
	font-size: 16px;
	font-weight: 500;
}
.prefmodal-subhead {
	color: var(--gray-500, #667085);
	font-family: "Inter", sans-serif;
	font-size: 14px;
	font-weight: 400;
}
</style>
<style scoped>
/* switch apps design */
.current-proj {
	border: 1px solid rgba(76, 120, 206, 0.5) !important;
	background: #e0eaff;
}
/* switch apps design */
.sp-main-container {
	border-radius: 8px;
	background: #e0eaff;
	padding: 4px;
}
.sp-license-container {
	position: absolute;
	border-radius: 12px;
	background: #fff;
	box-shadow: 0px 8px 8px -4px rgba(16, 24, 40, 0.03),
		0px 20px 24px -4px rgba(16, 24, 40, 0.08);
	padding: 16px;
	top: 50px;
	transform: translateX(-150px);
}
.sp-project-box {
	border-radius: 8px;
	border: 1px solid rgba(128, 128, 128, 0.16);
	display: flex;
	width: 81px;
	height: 68px;
	padding: 18px 24px 18px 25px;
	justify-content: center;
	align-items: center;
}
.sp-headings {
	color: #424242;
	font-family: "Inter", sans-serif;
	font-size: 16px;
	font-weight: 500;
}
.sp-subheadings {
	color: #667085;
	font-family: "Inter", sans-serif;
	font-size: 14px;
	font-weight: 400;
}

.login-det-container {
	background: #ffffff;
	border: 1px solid #f4f4f4;
	border-radius: 9px;
	padding: 10px;
}
.welcometext {
	font-weight: 400;
	font-size: 12px;
	color: #72738e;
}
.username {
	font-weight: 700;
	font-size: 12px;
	color: #72738e;
}
.logoutbox {
	position: absolute;
	z-index: 7;
	width: 100%;
	right: 0;
	top: 45px;
	padding: 2px;
	background: #ffffff;
	box-shadow: 0px 5.06149px 25.3074px rgba(196, 196, 196, 0.5);
	border-radius: 10px;
}
.dropdown-head {
	color: #72738e;
	font-weight: 600;
	font-size: 14px;
}
.logout-txt {
	font-weight: 400;
	font-size: 12px;
	color: #696969;
}
a:hover {
	text-decoration: none !important;
}

.switchtext {
	font-weight: var(--weight-LM);
	font-size: var(--size-12);
	color: #464667;
}
.tnt-sortcard {
	background: var(--bg-white);
	box-sizing: border-box;
	box-shadow: 0px 1px 4px rgb(0 0 0 / 25%);
	border-radius: 5px;
	top: 35px;
	right: -5px;
	padding: 5px 15px;
	position: absolute;
	z-index: 7;
	width: 250px;
	font-size: var(--size-13);
	color: #545454;
}
.headercard {
	width: 250px;
	top: 44px;
	right: 21px;
}
.breadcrumb {
	flex-wrap: nowrap;
}
.breadcrumb-ellipsis {
	width: 50px !important;
	text-overflow: ellipsis !important;
	white-space: nowrap !important;
	overflow: hidden !important;
}

.breadcrumb-ellipsis2 {
	max-width: 220px !important;
	text-overflow: ellipsis !important;
	white-space: nowrap !important;
	overflow: hidden !important;
}

.search-bar .search-input {
	height: 34px;
	background: #ffffff;
	border: 0.5px solid #c4c4c4;
	box-sizing: border-box;
	box-shadow: inset 0px 1px 3px rgba(0, 0, 0, 0.2);
	border-radius: 5px;
	padding: 0 30px !important;
	width: 100%;
}

.search-pos {
	position: absolute;
	top: 10px;
	left: 8px;
}
.breadcrumb-item + .breadcrumb-item:before {
	float: left;
	padding-right: 0.5rem;
	color: #6c757d;
	content: ">" !important;
}
.no-redirect {
	color: #97a8be;
	cursor: default;
}

.h-greenSel-g {
	border-radius: 100px;
	background: #f8f8f9;
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);

	height: 44px;
	width: 44px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
}

.h-greenSel-g:hover {
	border-radius: 100px;
	background: #f8f8f9;
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
	height: 44px;
	width: 44px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
}

.h-infotooltip {
	display: none;
	position: absolute;
	z-index: 5;
	top: 61px;
	left: -289px;
	border-radius: 6px;
	background: #fff;
	box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.25);
	color: #7a7a7a;
	font-size: 13px;
	font-weight: 500;
	white-space: nowrap;
	padding: 13px 20px;
}
.h-infotooltip::before {
	content: "";
	position: absolute;
	left: 311px;
	top: -14px;
	transform: translateX(-50%) rotate(45deg);
	width: 30px;
	height: 30px;
	background-color: white;
	z-index: 1;
}

.h-themechange {
	margin: 10px;
}

.h-theme-check {
	position: absolute;
	left: 45%;
	top: 40%;
}

.color-option.selected {
	margin: 10px;
	border: 2px solid #4c78ce;
	border-radius: 5px;
	position: relative;
	opacity: 0.7;
}
.color-option.unselected {
	margin: 10px;
	border: 2px solid transparent;
	border-radius: 5px;
	position: relative;
}

.themetxt {
	color: var(--Primary-Gray, #324054);
	font-size: 16px;
	font-weight: 500;
}

.header-tooltip {
	position: absolute;
	left: -43px;
	top: 53px;
	border-radius: 5px;
	border: 1px solid #01565b;
	background: #01565b;
	box-shadow: 0px 15px 30px 0px rgba(122, 122, 122, 0.2);
	white-space: nowrap;
	padding: 10px;
}

.header-tooltip::before {
	content: "";
	position: absolute;
	left: 63px;
	top: -5px;
	transform: translateX(-50%) rotate(45deg);
	width: 10px;
	height: 10px;
	border: 1px solid transparent;
	border-left-color: #01565b;
	border-top-color: #01565b;
	background-color: #01565b;
	z-index: 1;
}

.progressBar-box {
	border-radius: 10px;
	background: #e0eaff;
	padding: 8px 14px;
	width: 250px;
}

.progressBar-box .progress {
	height: 3px;
	background-color: #d9d9d9;
}

.progressBar-box .progress-bar {
	background-color: #20639b;
}
.pbar-text {
	color: #1a4164;
	font-family: "Poppins", sans-serif;
	font-size: 12px;
	font-weight: 400;
}

.pbar-bold {
	color: #1a4164;
	font-family: "Poppins", sans-serif;
	font-size: 12px;
	font-weight: 600;
}

.resume-disabletxt {
	color: #8dafcb;
	font-family: "Poppins", sans-serif;
	font-size: 12px;
	font-weight: 600;
}

.resume-txt {
	color: #20639b;
	font-family: "lato", sans-serif;
	font-size: 12px;
	font-weight: var(--weight-M);
}

.resume-box {
	/* padding: 3px; */
	position: relative;
}
.resume-box-white {
	background: transparent;
	/* padding: 3px; */
}
.home-page-line {
	position: absolute;
	background-color: #20639b;
	width: 70px;
	height: 3.5px;
	top: 50px;
	border-radius: 2px;
}

.resume-box-blue-line {
	position: absolute;
	background-color: #20639b;
	/* width: 100px; */
	width: 89px;
	height: 4px;
	top: 50px;
	border-radius: 2px;
}

.resume-main-container {
	position: absolute;
	right: 19px;
}

.resume-option-box {
	width: 260px;
	border-radius: 4px;
	background: #fff;
	box-shadow: 0px 1px 11px 0px rgba(0, 0, 0, 0.38);
	padding: 7px 10px;
}

.resumes-sub-container {
	width: 335px;
	border-radius: 4px;
	background: #fff;
	box-shadow: 0px 1px 11px 0px rgba(0, 0, 0, 0.38);
	padding: 7px 10px;
	z-index: 200;
	min-height: auto;
	max-height: 424px;
}

.resumes-sub-container-height {
	min-height: auto;
	max-height: 345px;
	overflow-y: auto;
	overflow-x: hidden;
}

.resumes-nodata-font {
	color: #3a3c40;
	font-size: 13px;
	font-weight: 500;
	font-family: "Lato", sans-serif;
}

.resumes-innercontent-font {
	color: #3a3c40;
	font-size: 13px;
	font-weight: 500;
	font-family: "Lato", sans-serif;
	padding: 5px 7px;
}

.resumes-innercontent {
	color: #3a3c40;
	font-size: 13px;
	font-weight: 500;
	background: #fff;
	padding: 10px;
	display: flex;
	align-items: center;
	cursor: pointer;
	font-family: "Lato", sans-serif;
}

.resumes-innercontent:hover {
	background: #e8eff4;
}

.viewAll-innercontent {
	color: #20639b;
	font-size: 14px;
	font-weight: 500;
	background: #fff;
	padding: 10px;
	cursor: pointer;
	font-family: "Lato", sans-serif;
}

.viewAll-innercontent:hover {
	background: #e8eff4;
}

.resumes-innercontent-font:hover {
	background: #e8eff4;
	border-radius: 4px;
}

.view-All-selected {
	background: #c8d9e5;
	border-radius: 8px;
	padding: 10px;
	cursor: pointer;
	color: #20639b;
	font-size: 14px;
	font-weight: 500;
	font-family: "Lato", sans-serif;
}

.profile-mid-line {
	border-bottom: 1px solid #8c8c8c;
	padding-bottom: 5px;
}

.profile-line {
	border-radius: 10px 10px 0px 0px;
	background: #20639b;
	position: absolute;
	width: 70px;
	height: 4px;
	bottom: -11px;
}

.profilepic-border {
	border-radius: 50%;
	border: 2.5px solid #20639b;
	height: 43px;
	width: 43px;
}

.profilepic-border:hover {
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.profilepic-border-active {
	border-radius: 50%;
	border: 2.5px solid #20639b;
	height: 43px;
	width: 43px;
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}
.profilepic-back {
	background-color: #20639b;
	border-radius: 50%;
	height: 43px;
	width: 43px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 25px;
	font-weight: 500;
	color: #fff;
	border: 2px solid #fff;
}

.profilepic-back:hover {
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.profilepic-back-active {
	background-color: #20639b;
	border-radius: 50%;
	height: 43px;
	width: 43px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 25px;
	font-weight: 500;
	color: #fff;
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
	border: 2px solid #fff;
}

.profile-container {
	background: #20639b;
	border-radius: 5px;
	padding: 5px;
}

.profile-container-font {
	color: #fff;
	font-size: 16px;
	font-weight: 500;
	font-family: "Lato", sans-serif;
}

.profile-container-img {
	border-radius: 50%;
	/* border: 2.5px solid #20639b; */
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
	height: 30px;
	width: 30px;
}

.profile-container-back {
	border-radius: 50%;
	border: 2.5px solid #fff;
	height: 30px;
	width: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 15px;
	font-weight: 500;
	color: #fff;
}

.profile-container-subhead {
	color: #3a3c40;
	font-size: 14px;
	font-weight: 500;
	font-family: "Lato", sans-serif;
}

.sign-out-font {
	color: #20639b;
	font-size: 14px;
	font-weight: 500;
	font-family: "Lato", sans-serif;
}

.new-profile-line {
	border-bottom: 1px solid #cdc9c9;
}

.hoverclass:hover {
	background: #e8eff4;
	padding: 0.25rem !important;
}

.draft-container {
	padding: 3px 5px;
	background: #e8eff4;
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	color: #3a3c40;
	background: rgba(32, 99, 155, 0.14);
	border-radius: 3px;
}

.tooltip {
	z-index: 3000;
}
.not-sel-home {
	color: #606060;
	font-size: var(--size-12);
	font-weight: var(--weight-M);
	font-family: "lato", sans-serif;
}
.gap-35 {
	gap: 35px;
}
.sp-active-main-container {
	background: #f6f9fb;
	padding: 6px;
	border-radius: 8px;
}
.allproj-dropdown {
	position: absolute;
	right: 0;
	top: 42px;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: flex-start;
	align-content: flex-start;
	padding: 16px;
	gap: 16px;
	background: #f6f9fb;
	border-width: 0px 1px 1px 1px;
	border-style: solid;
	border-color: #f6f9fb;
	box-shadow: 0px 83px 33px rgba(0, 0, 0, 0.01),
		0px 47px 28px rgba(0, 0, 0, 0.05), 0px 21px 21px rgba(0, 0, 0, 0.09),
		0px 5px 11px rgba(0, 0, 0, 0.1);
	border-radius: 16px 0px 16px 16px;
	width: 355px;
}

.allproj-card {
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	padding: 12px;
	gap: 8px;
	height: 136px;
	width: 148px;
	background: #ffffff;
	border: 1px solid rgba(224, 224, 224, 0.5);
	border-radius: 8px;
	cursor: pointer;
}

.allproj-card:hover {
	border: 1px solid #20639b;
}
.allproj-card-selected {
	background: #deecf6 !important;
	border: 1px solid #20639b !important;
}
.allproj-card-selected img {
	background: #fff !important;
	border-radius: 50% !important;
}

.allproj-card-head {
	font-family: "Inter", sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: 16px;
	line-height: 24px;
	letter-spacing: -0.03em;
	color: #20639b;
	backdrop-filter: blur(2px);
}

.allproj-card:hover .allproj-card-head {
	color: #20639b;
}

.allproj-card-subhead {
	font-family: "Inter", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	line-height: 16px;
	color: #333333;
}
</style>
<style>
.notificationdd .dropdown-header {
	padding: 0.75rem 1rem !important;
	border-bottom: 1px solid #dee2e6;
}
.unread {
	background-color: #e8eff4;
	border-radius: 5px;
}
.unread:hover {
	background: #c8dceb !important;
	border-radius: 5px;
}
.notification-active-class {
	filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
	border-radius: 4px;
}
.notificationdd .dropdown-menu {
	background-color: #ffffff;
	box-shadow: 0px 4px 34px rgba(196, 196, 196, 0.9);
	border-radius: 8px;
	border: unset;
}
.markallread {
	font-family: "Lato";
	font-style: normal;
	font-weight: 500;
	font-size: 10px;
	color: #7a7a7a;
}
.notihighlight {
	color: #20639b;
	font-weight: 600;
}
.notiitems:hover {
	background: linear-gradient(0deg, #f6f6f6, #f6f6f6), #e8eff4;
	border-radius: 5px;
}
.notificationdd .dropdown-menu {
	background-color: #ffffff;
	box-shadow: 0px 4px 34px rgba(196, 196, 196, 0.9);
	border-radius: 8px;
	border: unset;
}
.w-10 {
	width: 10% !important;
}
.notificationdd .btn:focus,
.btn.focus {
	box-shadow: unset;
}
</style>
